export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo19-607df256dca48e9e42bb0d293f670e06.jpg";